// ignore-string-externalization

import styled from 'styled-components';
import { Type, screenMdMin } from '@spotify-internal/encore-web-v5';
import {
  AnimationContextType,
  DELAYS,
  fadeInAnimation,
  withAnimationContext,
} from '@spotify-internal/frodor-modules';

export const Headline = withAnimationContext(
  styled(Type.h1).attrs({
    paddingBottom: '0.67em',
    variant: 'altoBrio',
    weight: 'bold',
  })<{ centered?: boolean; animationContext: AnimationContextType }>`
    ${fadeInAnimation(DELAYS.SECOND)};
    @media (min-width: ${screenMdMin}) {
      text-align: ${({ centered }) => (centered ? 'center' : 'left')};
    }
  `,
);
